/* theme.js — 3D Van Stuff */
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  /* ── Mobile nav ───────────────────────────────────────────────── */
  var mobileNav     = qs('#mobile-nav');
  var mobileToggle  = qs('#mobile-nav-toggle');
  var mobileClose   = qs('#mobile-nav-close');
  var mobileOverlay = qs('#mobile-nav-overlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileToggle)  mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  /* ── Cart drawer ─────────────────────────────────────────────── */
  var cartDrawer  = qs('#cart-drawer');
  var cartToggle  = qs('#cart-toggle');
  var cartClose   = qs('#cart-close');
  var cartOverlay = qs('#cart-overlay');
  var cartBody    = qs('#cart-body');
  var cartFoot    = qs('#cart-foot');
  var cartSubtotal= qs('#cart-subtotal');
  var cartCount   = qs('#cart-count');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCartDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (e) { console.error('Cart fetch error:', e); });
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (!cartBody) return;

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (cartFoot) cartFoot.hidden = true;
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var props = '';
      if (item.properties) {
        Object.entries(item.properties).forEach(function (kv) {
          if (kv[1]) props += '<p class="cart-drawer-item__prop"><strong>' + kv[0] + ':</strong> ' + kv[1] + '</p>';
        });
      }
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-drawer-item__variant">' + item.variant_title + '</p>' : '';
      html += '<div class="cart-drawer-item">'
        + '<img src="' + item.image + '" alt="' + item.title + '" class="cart-drawer-item__img">'
        + '<div class="cart-drawer-item__info">'
        + '<p class="cart-drawer-item__title">' + item.product_title + '</p>'
        + variant + props
        + '<p class="cart-drawer-item__price">Qty ' + item.quantity + ' &times; ' + formatMoney(item.price) + '</p>'
        + '<button class="cart-drawer-item__remove" data-key="' + item.key + '">Remove</button>'
        + '</div></div>';
    });

    cartBody.innerHTML = html;
    if (cartFoot) cartFoot.hidden = false;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    /* Remove buttons */
    qsa('.cart-drawer-item__remove', cartBody).forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeCartItem(this.dataset.key);
      });
    });
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(renderCart);
  }

  function updateCartCount(count) {
    if (!cartCount) return;
    cartCount.textContent = count;
    cartCount.classList.toggle('cart-badge--hidden', count === 0);
  }

  /* ── Product page: gallery ───────────────────────────────────── */
  var gallery = qs('#product-gallery');
  if (gallery) {
    var slides = qsa('.product-gallery__slide', gallery);
    var thumbs = qsa('.product-gallery__thumb', gallery);

    function showSlide(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { showSlide(idx); });
    });
  }

  /* ── Product page: variant selector ──────────────────────────── */
  var productForm = qs('#product-form');
  if (productForm) {
    var variantInput = qs('#variant-id', productForm);
    var atcBtn       = qs('#product-atc', productForm);
    var priceEl      = qs('#product-price');
    var optionBtns   = qsa('.product-option__btn', productForm);

    /* Track selected option values */
    var selectedOptions = {};

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = this.dataset.option;
        var val = this.dataset.value;
        selectedOptions[pos] = val;
        /* update active state per option group */
        qsa('[data-option="' + pos + '"]', productForm).forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.value === val);
        });
        findMatchingVariant();
      });
    });

    function findMatchingVariant() {
      var selected = Object.values(selectedOptions).join(' / ');
      var hidden = qs('input[name="id"]', productForm);
      if (!hidden) return;
      /* Iterate variants via meta tag if available, else fallback */
      var metaVariants = window.__productVariants;
      if (!metaVariants) return;
      var match = metaVariants.find(function (v) {
        return v.options.join(' / ').toLowerCase() === selected.toLowerCase();
      });
      if (match) {
        hidden.value = match.id;
        if (priceEl) priceEl.innerHTML = '<span class="product-info__current">' + formatMoney(match.price) + '</span>';
        if (atcBtn) { atcBtn.disabled = !match.available; atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
      }
    }

    /* ATC submit via AJAX */
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var vid = parseInt(variantInput ? variantInput.value : qs('input[name="id"]', productForm).value, 10);
      var qty = parseInt((qs('#product-qty', productForm) || {}).value || 1, 10);
      if (!vid) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.id) {
          atcBtn.textContent = 'Added ✓';
          fetchCart();
          openCartDrawer();
          setTimeout(function () {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to Cart';
          }, 2500);
        } else {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        }
      })
      .catch(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Try again';
      });
    });

    /* Qty inputs on product page */
    qsa('.qty-input__btn', productForm).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var field = qs('.qty-input__field', this.closest('.qty-input'));
        if (!field) return;
        var val = parseInt(field.value, 10) || 1;
        if (this.dataset.action === 'increase') field.value = val + 1;
        if (this.dataset.action === 'decrease' && val > 1) field.value = val - 1;
      });
    });
  }

  /* ── Cart page qty inputs ────────────────────────────────────── */
  qsa('.cart-page__form .qty-input__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var field = qs('.qty-input__field', this.closest('.qty-input'));
      if (!field) return;
      var val = parseInt(field.value, 10) || 1;
      if (this.dataset.action === 'increase') field.value = val + 1;
      if (this.dataset.action === 'decrease') field.value = Math.max(0, val - 1);
    });
  });

  /* Close drawers on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileNav();
    }
  });

  /* Initial cart count */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) { updateCartCount(c.item_count); });

})();
